import {Injectable} from '@angular/core';
import {WebsocketService} from "../../websocket/websocket.service";
import {TableWsService} from "../../websocket/table-ws.service";

@Injectable({
  providedIn: 'root'
})
export class ClearingTradeWsService extends TableWsService{

  constructor(websocketService: WebsocketService) {
    super(websocketService, 'trade');
  }

}
